import { render, staticRenderFns } from "./sidebarComments.vue?vue&type=template&id=632c4e89&"
import script from "./sidebarComments.vue?vue&type=script&lang=js&"
export * from "./sidebarComments.vue?vue&type=script&lang=js&"
import style0 from "./sidebarComments.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports